define('app/sdc/get/controller/sdc-get-controller',["$parse"], function ($parse) {
	return {
		// Require specifies controllers to look for
		// These will be bound to your controller on PostLink (After the constructor)
		require: {

		},
		controller: {
			// Bind attributes here
			bind: {
				"sdcGetController": "@"
			},
			// Define functions here and default properties that are simple types (not objects or arrays)
			prototype: {

			},
			// Define properties with getter/setters
			properties: {

			},
			// Define the constructor, the parameters here are injected, you must use injection to get any of the following
			// $scope, $element, $attrs, $transclude
			// Also note that controllers from the require property will not exist at this stage and are only added after linking
			constructor: ["$scope", "$element", "$attrs", "$transclude", "$watch", "$self", function ($scope, $element, $attrs, $transclude, $watch, vm) {
				
			}]
		},
		link: ["$scope", "$element", "$attrs", "$controllers", "$transclude", "$self", "$parent", function ($scope, $element, $attrs, $controllers, $transclude, vm, $parent) {

		}]
	}
});
